var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigninIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46.27a.54.54 0 0 0-.49.54v4.95a.54.54 0 1 0 1.08 0V1.35h10.8v18H4.05v-4.41a.54.54 0 1 0-1.08 0v4.95c0 .298.242.54.54.54h11.88a.54.54 0 0 0 .54-.54V.81a.54.54 0 0 0-.54-.54H3.51a.72.72 0 0 0-.05 0zm3.294 4.942a.54.54 0 0 0-.295.936l3.873 3.662H.76a.562.562 0 0 0-.515.565.562.562 0 0 0 .565.515h9.522l-3.873 3.653a.54.54 0 0 0 .742.785l4.86-4.59a.54.54 0 0 0 0-.785l-4.86-4.59a.54.54 0 0 0-.447-.151z",
    fill: "#999",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninIcon);
export default __webpack_public_path__ + "static/media/signin-icon.16f84bfd99d09e0d1fd35e33f1394824.svg";
export { ForwardRef as ReactComponent };